<template>
	<div class="user-profile">
		<div class="card wrapper">
			<ul class="tabs">
				<li class="tab">
					<label>
						<input
							type="radio"
							:value="1"
							v-model="activeView"
						>

						<span>
							User Information
						</span>
					</label>
				</li>

				<li class="tab">
					<label>
						<input
							type="radio"
							:value="2"
							v-model="activeView"
						>

						<span>
							 Mood Stream
						</span>
					</label>
				</li>
			</ul>

			<section
				class="content-wrapper"
				v-show="activeView === 1"
			>
				<user-information :user="user" :daily="calendarDaily" v-show="activeView === 1"></user-information>
			</section>

			<section
				class="content-wrapper"
				v-show="activeView === 2"
			>
				<div
					class="controls"
				>
					<button class="btn-primary" @click="showReportForm()">
						Report
					</button>

					<button
						class="btn-primary"
						@click="downloadUserProfile"
						:disabled="userProfileExcelLoading"
					>
						Download File
					</button>
				</div>

				<mood-stream :id="id"></mood-stream>
			</section>
		</div>

		<report-file-form
			v-if="modalName.includes('report-file-form')"
			@close="$store.dispatch('closeModal')"
		/>
	</div>
</template>

<script>
import UserInformation from '@/components/user-profile/UserInformation.vue'
import MoodStream from '@/components/user-profile/MoodStream.vue'
import ReportFileForm from '@/components/user-profile/ReportFileForm.vue'

import * as userModule from '@/store/user'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	props: ['id'],

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['user/']) {
			this.$store.registerModule('user', userModule.default)
		}
	},

	beforeRouteLeave (to, from, next) {
		if (to.name !== 'users') {
			this.lastQueryParams = ''
		}
		next()
	},

	created () {
		this.$store.dispatch('user/viewUser', this.id)
	},

	data () {
		return {
			activeView: 1
		}
	},

	computed: {
		...mapGetters('user', {
			user: 'getUserView',
			userLoading: 'getUserViewLoading',
			userProfileExcelLoading: 'getUserProfileExcelLoading'
		}),

		...mapGetters({
			modalName: 'modalName'
		}),

		...mapFields('user', {
			calendarDaily: 'calendarDaily',
			calendarDate: 'calendarDate',
			lastQueryParams: 'lastQueryParams'
		})
	},

	methods: {
		/* Report Download */
		showReportForm () {
			this.$store.commit('toggleModal', {
				modalName: 'report-file-form'
			})
		},

		downloadUserProfile () {
			const { filters } = this.$options
			const form = new FormData()
			form.append('id', this.id)
			form.append('date', filters.dateFormatter(this.calendarDate, 'YYYY-MM-DD'))
			this.$store.dispatch('user/downloadUserProfileExcel', form)
		}
	},

	components: {
		UserInformation,
		MoodStream,
		ReportFileForm
	}
}
</script>

<style lang="scss" scoped>
.user-profile {
	height: 100%;

	.wrapper {
		height: 100%;
		width: 100%;
		@include flex-column;
		position: relative;
	}

	.tabs {
		@include flex-row;
		border-bottom: 2px solid $light;

		.tab {
			display: inline-block;
			padding-bottom: 15px;
			padding-right: 20px;
			color: $dark;

			&:hover,
			label > input[type=radio]:checked + span {
				color: $dark2;
				font-weight: 600;
			}

			label {
				font-weight: 400;
				cursor: pointer;
				position: relative;

				input {
					position: absolute;
					top: 0;
					left: 0;
					opacity: 0;
				}
			}
		}
	}

	.content-wrapper {
		flex: 1 1 auto;
		padding: 10px 0;
		@include flex-row;
	}

	.controls {
		@include flex-row(flex-end, center);
		position: absolute;
		right: 20px;
		top: 10px;

		button {
			margin-left: 10px;
		}
	}
}
</style>
